import { createContext, useCallback, useContext, useMemo, useState } from "react";

import ChangePinModal from "../jsx/components/Modals/ChangePinModal";
import ForgotPinModal from "../jsx/components/Modals/ForgotPinModal";

const SecurityModalsContext = createContext(null);

export const SecurityModalsProvider = ({ children }) => {
  const [changePinOpen, setChangePinOpen] = useState(false);
  const [forgotPinOpen, setForgotPinOpen] = useState(false);

  const openChangePin = useCallback(() => setChangePinOpen(true), []);
  const openForgotPin = useCallback(() => setForgotPinOpen(true), []);

  const value = useMemo(
    () => ({ openChangePin, openForgotPin }),
    [openChangePin, openForgotPin]
  );

  return (
    <SecurityModalsContext.Provider value={value}>
      {children}
      <ChangePinModal show={changePinOpen} onHide={() => setChangePinOpen(false)} />
      <ForgotPinModal show={forgotPinOpen} onHide={() => setForgotPinOpen(false)} />
    </SecurityModalsContext.Provider>
  );
};

export const useSecurityModals = () => {
  const ctx = useContext(SecurityModalsContext);
  if (!ctx) {
    throw new Error("useSecurityModals must be used inside a SecurityModalsProvider");
  }
  return ctx;
};
